module.exports = __webpack_public_path__ + "static/media/28DGC9.ff8b4e12.jpg";